import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserInfo } from '~models';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class UserService {
  private userInfoCache?: Observable<UserInfo>;

  constructor(private ngHttp: HttpClient, private oauthService: OAuthService) {}

  getUserInfo(): Observable<UserInfo> {
    const defaultUserInfo: UserInfo = {};

    if (!this.oauthService.hasValidAccessToken()) {
      return of(defaultUserInfo);
    }

    let url = `${environment.apiHost}/user/current`;

    if (!this.userInfoCache) {
      this.userInfoCache = this.ngHttp.get<UserInfo>(url).pipe(
        shareReplay(1),
        catchError((err) => {
          this.userInfoCache = undefined;
          throw err;
        }),
      );
    }

    return this.userInfoCache;
  }
}
